"use client";

import { ErrorView } from "@/components/errors/ErrorView";

export default function LanguageError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <ErrorView boundary="LanguageErrorBoundary" error={error} reset={reset} />
  );
}
